export function TextField({
		onChange,
		label,
		subLabel,
		hint,
		value,
		defaultValue,
		type,
		style,
		name,
		id,
		datalist,
		suggestions,
		required,
		disabled,
		hidden
}){
	const list_id = id == null || id == "" ? `${label}-data-list` : `${id}-data-list`
	return (
		<div className="textfield-div" style={style} >
			<label >{label} <span className="subLabel">{subLabel}</span></label>
			<input
				onChange={onChange}
				type={type ?? "text"}
				name={name ??""}
				placeholder={hint}
				value={value}
				defaultValue={defaultValue}
				hidden={hidden}
				id={id}
				list={datalist != null ? list_id : null}
				required={required ?? false}
				disabled={disabled ?? false}
			/>
			{ datalist != null &&
				<datalist id={list_id}>
						{datalist.map((entry,index)=> <option value={entry} key={index}/>)}

				</datalist>
			}
			{suggestions &&
			<div className="suggestions">
				<ul>
					{suggestions.map((item, index) => (
						<li
							key={index}
							// onClick={() => handleSelect(item)}
						>
							{item}
						</li>
					))}
				</ul>
			</div>}
		</div>
	)
}

export function TextArea({ onChange,label,subLabel, value,style,name,id, required}){
	return (
		<div className="textfield-div" style={style} >
			<label>{label} <span className="subLabel">{subLabel}</span></label>
			<textarea onChange={onChange} name={name} id={id}
			required={required} defaultValue={value??''}></textarea>
		</div>
	)
}
